// @flow

import { useState, useEffect, useMemo, useCallback } from 'react'
import Cookie from 'js-cookie'

const IOS_STORE_URL = 'https://apps.apple.com/jp/app/id973447544'
const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.spacemarket'

export const APP_LINK_URL_LOGIN = 'https://spacemarket.onelink.me/Mj3a/8bkg907n'
export const APP_LINK_URL_SIGNUP = 'https://spacemarket.onelink.me/Mj3a/612n5w21'
export const APP_LINK_URL_LOGIN_QR = 'https://spacemarket.onelink.me/Mj3a/a13y82ei'
export const APP_LINK_URL_SIGNUP_QR = 'https://spacemarket.onelink.me/Mj3a/7stsilov'

export const buildAppLinkHref = ({
  appLinkUrl,
  deepLink,
  promotionLinkParams = '',
}) => {
  // AppsFlyerの新旧ディープリンク互換のため、同じ遷移先を両方に渡す。
  const queryStart = promotionLinkParams
    ? `?${promotionLinkParams.slice(1)}&deep_link_value=deeplink&deep_link_sub1=${deepLink}&af_dp=${deepLink}`
    : `?deep_link_value=deeplink&deep_link_sub1=${deepLink}&af_dp=${deepLink}`
  return `${appLinkUrl}${queryStart}`
}

export const useAppLink = ({ afDp, appLinkUrl } = {}) => {
  const promotionLinkParams = useMemo(() => {
    const cookies = Cookie.get() || {}
    const promotionLinkCookies = Object.entries(cookies).filter(([cookieKey]) =>
      cookieKey.includes('sm_pl'),
    )

    if (promotionLinkCookies.length === 0) return ''

    const formattedPromotionLinkCookies = promotionLinkCookies.map(
      ([cookieKey, timestamp]) => {
        const capturingOwnerIdRegex = /^sm_pl_(?<ownerId>\d+)$/
        const found = capturingOwnerIdRegex.exec(cookieKey)
        const ownerId = found?.groups?.ownerId
        if (!ownerId) return ''
        return `&pl_${ownerId}=${String(timestamp)}`
      },
    )

    return formattedPromotionLinkCookies.join('')
  }, [])

  // SSRではwindow.location.hrefを参照できないため、mount後に完全URLへ差し替える。
  const [appLinkHref, setAppLinkHref] = useState(appLinkUrl)

  useEffect(() => {
    const deepLink = afDp ?? window.location.href
    setAppLinkHref(buildAppLinkHref({ appLinkUrl, deepLink, promotionLinkParams }))
  }, [afDp, appLinkUrl, promotionLinkParams])

  const handleAppLinkClick = useCallback(e => {
    if (typeof window === 'undefined') return

    const ua = window.navigator.userAgent.toLowerCase()
    const isAndroid = ua.includes('android')
    const isIOS =
      ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')
    const isMobile = isAndroid || isIOS
    const storeUrl = isAndroid ? ANDROID_STORE_URL : IOS_STORE_URL

    if (!isMobile) {
      e.preventDefault()
      window.location.href = storeUrl
    }
  }, [])

  return { appLinkHref, handleAppLinkClick }
}
